var map = {
	"./aDonkiKong_350x350.jpg": "9e06",
	"./aMnkyJump_350x350.jpg": "66c6",
	"./b97839825_350x350.jpg": "f293",
	"./fFishParad_350x350.jpg": "9acc",
	"./s5ForStar_350x350.jpg": "acf6",
	"./s7Dragons_350x350.jpg": "9c6b",
	"./sAztecGolT_350x350.jpg": "7a3c",
	"./sBuffK_350x350.jpg": "dd6c",
	"./sCaiShen_350x350.jpg": "16ba",
	"./sCandyBona_350x350.jpg": "d33d",
	"./sCandyXmas_350x350.jpg": "3d65",
	"./sClaFruit7_350x350.jpg": "fc4d",
	"./sCrazyMkDx_350x350.jpg": "35be",
	"./sCrazyMnky_350x350.jpg": "86e8",
	"./sDblMnky_350x350.jpg": "a1ff",
	"./sDiamond7_350x350.jpg": "5bd7",
	"./sDolphDive_350x350.jpg": "3c41",
	"./sDrgBlitz_350x350.jpg": "59a9",
	"./sEternalFi_350x350.jpg": "6e85",
	"./sForToad_350x350.jpg": "9d95",
	"./sForestSec_350x350.jpg": "414c",
	"./sFruitTyc_350x350.jpg": "b1de",
	"./sGolWest_350x350.jpg": "9d54",
	"./sGoldenFa_350x350.jpg": "18c7",
	"./sGoldenWar_350x350.jpg": "2f5a",
	"./sHighwayB_350x350.jpg": "6dcc1",
	"./sHolyGoat_350x350.jpg": "3333",
	"./sHoney888_350x350.jpg": "01b1",
	"./sHotSmash_350x350.jpg": "e99e",
	"./sJokerKing_350x350.jpg": "0417",
	"./sLightnDrg_350x350.jpg": "e127",
	"./sLightnWmn_350x350.jpg": "d388",
	"./sLongX3_350x350.jpg": "0106",
	"./sLuckyGems_350x350.jpg": "02f6",
	"./sMahPhe_350x350.jpg": "fa1d",
	"./sMayaQuest_350x350.jpg": "ee61",
	"./sMrHippo_350x350.jpg": "6a96",
	"./sOceanChes_350x350.jpg": "d735",
	"./sPrinCrime_350x350.jpg": "5ec5",
	"./sPrincessR_350x350.jpg": "737e",
	"./sRickyTyco_350x350.jpg": "94f2",
	"./sRomaII_350x350.jpg": "11b2",
	"./sRoma_350x350.jpg": "22a3",
	"./sShkBoomX2_350x350.jpg": "52a0",
	"./sShkThaiX2_350x350.jpg": "a6ec",
	"./sSoccerK_350x350.jpg": "39e3",
	"./sSuperFor_350x350.jpg": "1bab",
	"./sSweetLava_350x350.jpg": "c5c2",
	"./sTaiga88_350x350.jpg": "3962",
	"./sTriKfMnky_350x350.jpg": "4fc2",
	"./sTriMnky_350x350.jpg": "a38d",
	"./sTwinkleIc_350x350.jpg": "02bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0fb2";